<template>
  <div class="order-card mb-3">
    <div class="card">
      <div class="card-body p-3">
        <div class="d-flex justify-content-between mb-1">
          <div>
            <div class="text-muted small mb-1">SKU: {{ order.sku }}</div>
            <h6 class="fw-bold mb-2">{{ order.product_name }}</h6>
          </div>
          <div 
            class="cursor-pointer text-muted"
            @click="$emit('remove-item')"
            v-if="!isSummary"
          >
            <i class="fa fa-times"></i>
          </div>
        </div>

        <div class="row gx-2 mb-2">
          <div class="col-4">
            <div class="text-muted small">Stock Available</div>
            <div class="fw-medium">{{ order.available_quantity }}</div>
          </div>
          <div class="col-4">
            <div class="text-muted small">Unit Price</div>
            <div class="fw-medium">${{ $filters.moneyFormat(order.unit_cost) }}</div>
          </div>
          <div class="col-4">
            <div class="quantity-section">
              <div class="text-muted small mb-1">Quantity</div>
              <div class="d-flex align-items-center gap-2" v-if="!isSummary">
                <div class="text-muted small" style="min-width: 45px">Min {{ minQuantity }}</div>
                <input
                  type="number" 
                  class="form-control form-control-sm"
                  :min="minQuantity"
                  @change="$emit('calculate')"
                  @input="$emit('update-quantity', $event)"
                  v-model="order.quantity"
                />
              </div>
              <div v-else>{{ order.quantity }}</div>
            </div>
          </div>
        </div>

        <div class="subtotal-section pt-2 border-top">
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-muted small">Subtotal</div>
            <div class="fw-bold">
              <span v-if="order.quantity > 0">
                ${{ $filters.moneyFormat(order.sub_total) }}
              </span>
              <span v-else>$0.00</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileOrderCard',
  props: {
    order: {
      type: Object,
      required: true
    },
    minQuantity: {
      type: Number,
      default: 5
    },
    isSummary: {
      type: Boolean,
      default: false
    }
  },
  emits: ['remove-item', 'calculate', 'update-quantity']
}
</script>

<style scoped>
.order-card .card {
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  border: 1px solid #dee2e6;
}

.form-control {
  height: 38px;
  width: 100%;
  max-width: 120px;
}

.fw-medium {
  font-weight: 500;
}

.gap-2 {
  gap: 0.5rem;
}

@media (max-width: 375px) {
  .card-body {
    padding: 0.75rem;
  }
  
  .form-control {
    height: 36px;
  }
}
</style>